import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Occ, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

import { DpBaseStoreService } from '@app/core/services/base-store.service';

@Injectable({ providedIn: 'root' })
export class DpBaseStoreApiService {
  readonly #httpClient = inject(HttpClient);
  readonly #occEndpoints = inject(OccEndpointsService);
  readonly #baseStoreService = inject(DpBaseStoreService);

  constructor() {
    this.fetchAndGetShopOpenStatus().pipe(take(1)).subscribe();
  }

  // ask BE and return shop open status
  fetchAndGetShopOpenStatus(): Observable<boolean> {
    const url = this.#occEndpoints.buildUrl('shopOpen');

    return this.#httpClient.get<Occ.BaseStore>(url).pipe(
      take(1),
      map((baseStore) => !!baseStore.open),
      tap((isOpen) => this.#baseStoreService.setShopOpenValue(isOpen))
    );
  }

  // get shop status from last call (should be used in .html
  isShopOpen(): Observable<boolean> {
    return this.#baseStoreService.isShopOpen$();
  }
}
